import { useMemo } from 'react';

export const useSummaryTrackedActivitiesComponentLogic = ({ api }) => {
    const activeData = useMemo(() => {
        if (api.getTrackedActivities.data) {
            const current = api.getTrackedActivities.data.periodItemsList.find((item) => item.id === 'all');
            return current ? current.itemsList : [];
        }
        return [];
    }, [api.getTrackedActivities.data]);

    const counter = activeData?.length ? `(${activeData.length})` : undefined;

    return {
        logic: {
            activeData,
            counter,
        },
    };
};
